import { LayoutDashboard, Building2, ClipboardList, FileText, Receipt, PlusCircle, Briefcase, HardHat, Users, DollarSign, Wrench, CalendarDays, CreditCard, Repeat, ClipboardCheck, Trophy, ShieldAlert, BarChart3, Mail, Bell, BellRing, Wand2, MessageSquare, BookOpen, RefreshCw, Inbox } from "lucide-react";

export function getNav(role, orgRole) {
  switch (role) {
    case "client": {
      const isViewer = orgRole === "viewer";
      const items = [
        { to: "/app/client", label: "Dashboard", icon: LayoutDashboard },
        { to: "/app/client/properties", label: "Properties", icon: Building2 },
        { to: "/app/client/request", label: "Request Service", icon: PlusCircle },
        { to: "/app/client/work-orders", label: "Work Orders", icon: ClipboardList },
        { to: "/app/schedule", label: "Schedule", icon: CalendarDays },
        { to: "/app/recurring", label: "Recurring", icon: Repeat },
        { to: "/app/turnovers", label: "Turnovers", icon: ClipboardCheck },
        { to: "/app/client/estimates", label: "Estimates", icon: FileText },
        { to: "/app/client/invoices", label: "Invoices", icon: Receipt },
        { to: "/app/client/team", label: "Team", icon: Users },
        { to: "/app/client/plans", label: "Plans", icon: CreditCard },
        { to: "/app/notifications", label: "Notifications", icon: Bell },
      ];
      return isViewer ? items.filter((i) => i.to !== "/app/client/request") : items;
    }
    case "contractor":
      return [
        { to: "/app/contractor", label: "Jobs", icon: Briefcase },
        { to: "/app/contractor/available", label: "Available", icon: Wrench },
        { to: "/app/schedule", label: "Schedule", icon: CalendarDays },
        { to: "/app/contractor/earnings", label: "Earnings", icon: DollarSign },
        { to: "/app/contractor/payouts", label: "My Payouts", icon: CreditCard },
        { to: "/app/contractor/profile", label: "Profile", icon: HardHat },
        { to: "/app/notifications", label: "Notifications", icon: Bell },
      ];
    case "tenant":
      return [
        { to: "/app/tenant", label: "My Requests", icon: ClipboardList },
        { to: "/app/tenant/new", label: "New Request", icon: PlusCircle },
        { to: "/app/notifications", label: "Notifications", icon: Bell },
      ];
    case "dispatcher":
      return [
        { to: "/app/dispatch", label: "Dispatch Board", icon: LayoutDashboard },
        { to: "/app/dispatch/work-orders", label: "Work Orders", icon: ClipboardList },
        { to: "/app/schedule", label: "Schedule", icon: CalendarDays },
        { to: "/app/dispatch/contractors", label: "Contractors", icon: Users },
        { to: "/app/dispatch/crm", label: "CRM Leads", icon: Trophy },
        { to: "/app/admin/dispatch", label: "AI Dispatch", icon: Wand2 },
        { to: "/app/admin/invoices", label: "Invoices & Payments", icon: Receipt },
        { to: "/app/recurring", label: "Recurring", icon: Repeat },
        { to: "/app/turnovers", label: "Turnovers", icon: ClipboardCheck },
      ];
    case "admin":
      return [
        { to: "/app/admin", label: "Executive", icon: LayoutDashboard },
        { to: "/app/dispatch", label: "Dispatch Board", icon: Briefcase },
        { to: "/app/dispatch/work-orders", label: "Work Orders", icon: ClipboardList },
        { to: "/app/schedule", label: "Schedule", icon: CalendarDays },
        { to: "/app/dispatch/contractors", label: "Contractors", icon: Users },
        { to: "/app/admin/performance", label: "Performance", icon: Trophy },
        { to: "/app/admin/documents", label: "Documents", icon: ShieldAlert },
        { to: "/app/recurring", label: "Recurring", icon: Repeat },
        { to: "/app/turnovers", label: "Turnovers", icon: ClipboardCheck },
        { to: "/app/admin/reports", label: "Reports", icon: BarChart3 },
        { to: "/app/admin/invoices", label: "Invoices & Payments", icon: Receipt },
        { to: "/app/admin/contractor-payouts", label: "Contractor Payouts", icon: DollarSign },
        { to: "/app/admin/upload-review", label: "Upload Review", icon: ClipboardCheck },
        { to: "/app/admin/service-requests", label: "Service Requests", icon: Inbox },
        { to: "/app/dispatch/crm", label: "CRM Leads", icon: Trophy },
        { to: "/app/admin/markets", label: "Markets", icon: Building2 },
        { to: "/app/admin/email", label: "Email Settings", icon: Mail },
        { to: "/app/admin/sms", label: "SMS Settings", icon: MessageSquare },
        { to: "/app/admin/dispatch", label: "AI Dispatch", icon: Wand2 },
        { to: "/app/admin/notifications", label: "Notification Types", icon: BellRing },
        { to: "/app/admin/quickbooks", label: "QuickBooks", icon: BookOpen },
        { to: "/app/admin/quickbooks/sync", label: "Sync Center", icon: RefreshCw },
        { to: "/app/admin/email-queue", label: "Email Queue", icon: Mail },
      ];
    default:
      return [];
  }
}
